import request from '@/utils/http'

export function rankListApi() {
  const url = 'office_web/get_list/'
  request.get(url)
}
